import { defineStore } from "pinia";
import { ref } from "vue";

export const useBrowserSession = defineStore('browserSessionSettingsStore', () => {

  const settings = ref({
    defaults: {
      "SegnalazioneFauna": {
        "classe_id": 6,
        "specie_id": 11,
      },
      "SegnalazioneFlora": {
        "specie_id": 1153,
      },
    }
  }
  )

  return {
    settings,
  }
})
